module.exports = __webpack_public_path__ + "static/intro-background-48209fdd21f4f7091a644b1b730d6f6a.jpg";